import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { CommonService } from '../../../services/common/common.service';
import { ToolsService } from '../../../services/tools/tools.service';
import { Column } from '../../interfaces/column.interface';
import { IngredientsDataService, IngredientsColumnsService } from '../../services';
import { DialogIngredientFormComponent } from './ingredient-form/ingredient-form.component';
import { DialogIngredientDetailsComponent } from './ingredient-details/ingredient-details.component';
import { Ingredient, IngredientsResult } from '../../interfaces';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-ingredients',
  templateUrl: './ingredients.component.html',
  styleUrls: ['./ingredients.component.scss'],
  providers: [MessageService, ConfirmationService, DialogService],
})
export class IngredientsComponent implements OnInit, OnDestroy {

  private ingredientAddDialog: DynamicDialogRef = new DynamicDialogRef();
  private ingredientEditDialog: DynamicDialogRef = new DynamicDialogRef();
  private ingredientDetailsDialog: DynamicDialogRef = new DynamicDialogRef();
  public ingredientToDelete: Ingredient = {};
  public ingredients: Ingredient[] = [];
  public ingredient: Ingredient = {};
  public selectedIngredients: Ingredient[] = [];
  public submitted: boolean = false;
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '100'};
  public chunkSize: number = 200;
  public columns: Column[] = [];
  public isLoading: boolean = false;
  public isInitialized: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  private _selectedColumns: Column[] = [];
  @ViewChild('importer', { static: false })
  public importer?: FileUpload;
  public importChooseLabel: string = 'Import';
  public importLabel: string = 'Import CSV';

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private common: CommonService,
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ingredientsDataService: IngredientsDataService,
    private ingredientsColumnsService: IngredientsColumnsService,
  ) {
    this.importChooseLabel = this.translate.instant('IMPORT');
    this.importLabel = this.translate.instant('IMPORTCSV');
  }

  ngOnInit(): void {
    console.log('IngredientsComponent', 'ngOnInit');
    this.isInitialized = true;
    this.titleService.setTitle('Ingredients - Management');
    this.primengConfig.ripple = true;
    this.getIngredients();
  }

  ngOnDestroy(): void {
    console.log('IngredientsComponent', 'ngOnDestroy');
    this.isInitialized = false;
  }

  getIngredients(): void {
    // if (!this.isInitialized) {
    //   return;
    // }
    // if (parseInt(this.parameters.offset + '', 10) === 0) {
    //   this.isLoading = true;
    // }
    this.ingredientsDataService.getIngredients(this.parameters).subscribe((response: IngredientsResult|any) => {
      console.log(response)
      this.isLoading = false;
      if (response !== null) {
        this.setColumns();
        if (parseInt(this.parameters.offset + '', 10) === 0) {
          this.ingredients = response.success.data;
        } else {
          this.ingredients = this.ingredients.concat(response.success.data);
        }
        if (response.inlineCount > this.ingredients.length) {
          this.parameters.offset = (parseInt(this.parameters.offset + '', 10) + parseInt(this.parameters.limit + '', 10)) + '';
          this.getIngredients();
        } else {
          this.parameters.offset = '0';
        }
      }
    }, (error: any) => {;
      this.isLoading = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTSNOTLOADED')});
    });
  }

  importIngredients(event: any): void {
    if (typeof event.currentFiles === 'undefined') {
      return;
    }
    if (event.currentFiles.length === 0) {
      return;
    }
    const inputFile = event.currentFiles[0];
    const reader = new FileReader();
    let rows: any[] = [];
    reader.onload = (e: any) => {
      if (typeof this.importer !== 'undefined') {
        this.importer.clear();
      }
      const text = <string>e.target.result;
      rows = ToolsService.csvToArray(this.columns, text, ',');
      if (rows.length > 0) {
        let proceed = 0;
        const j = rows.length;
        for (let i = 0; i < j; i += this.chunkSize) {
          this.isLoading = true;
          const chunk = rows.slice(i, i + this.chunkSize);
          if (typeof chunk[0].id === 'undefined') {
            this.ingredientsDataService.addIngredients(chunk).subscribe((response: any) => {
              this.isLoading = false;
              if (typeof response.length !== 'undefined') {
                proceed += response.length;
                this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: proceed + ' ' + this.translate.instant('INGREDIENTSCREATED')});
                if (proceed === j) {
                  this.getIngredients();
                }
              } else {
                this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTSNOTCREATED')});
              }
            }, (error: any) => {
              this.isLoading = false;
              console.warn('import error', error);
              let msg = '';
              if (typeof error.error.length !== 'undefined') {
                msg = error.error;
              } else if (typeof error.error.errors.errors.children !== 'undefined') {
                const children = error.error.errors.errors.children;
                for (const field in children) {
                  if (typeof children[field].errors !== 'undefined') {
                    msg += field + ' ' + children[field].errors.join(', ');
                  }
                }
              }
              this.messageService.add({severity: 'warn', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTSNOTCREATED') + ' ' + msg});
            });
          } else {
            this.ingredientsDataService.updateIngredients(chunk).subscribe((response: any) => {
              this.isLoading = false;
              if (typeof response.length !== 'undefined') {
                proceed += response.length;
                this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: proceed + ' ' + this.translate.instant('INGREDIENTSUPDATED')});
                if (proceed === j) {
                  this.getIngredients();
                }
              } else {
                this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTSNOTUPDATED')});
              }
            }, (error: any) => {
              this.isLoading = false;
              console.warn('import error', error);
              let msg = '';
              if (typeof error.error.length !== 'undefined') {
                msg = error.error;
              } else if (typeof error.error.errors.errors.children !== 'undefined') {
                const children = error.error.errors.errors.children;
                for (const field in children) {
                  if (typeof children[field].errors !== 'undefined') {
                    msg += field + ' ' + children[field].errors.join(', ');
                  }
                }
              }
              this.messageService.add({severity: 'warn', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTSNOTCREATED') + ' ' + msg});
            });
          }
        }
      }
    };
    reader.readAsText(inputFile);
  }

  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.ingredientsColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }

  @Input()
  get selectedColumns(): any[] {
      return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
      // restore original order
      this._selectedColumns = this.columns.filter((col: any) => val.includes(col));
      this.updateColumns();
  }

  updateColumns() {
    for (let i = 0; i < this.columns.length; i++) {
      const show = this._selectedColumns.includes(this.columns[i]);
      this.columns[i].show = show;
      this.navigation.setParamValue('ingredients.' + this.columns[i].field + '.showFiled', show);
    }
  }

  deleteSelectedIngredients() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected Ingredients?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.ingredientsDataService.deleteIngredients(this.selectedIngredients).subscribe((response) => {
          if (response === null) {
            this.messageService.clear();
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Ingredients Deleted', life: 3000});
            this.getIngredients();
          } else {
            this.messageService.clear();
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Ingredients not deleted'});
          }
        }, (error: any) => {
          this.messageService.clear();
          this.messageService.add({severity: 'error', summary: 'Error', detail: 'Ingredients not deleted'});
        });
        this.selectedIngredients = [];
      }
    });
  }

  exportPdf() {
    ToolsService.exportPdf(this.ingredients, this.columns, 'Ingredients');
  }

  exportExcel() {
    ToolsService.exportExcel(this.ingredients, this.columns, 'Ingredients');
  }

  exportCsv() {
    ToolsService.exportCsv(this.ingredients, this.columns, 'Ingredients');
  }

  refresh() {
    this.ingredientsDataService.clearCache();
    this.getIngredients();
  }

  ingredientAdd(): void {
    if (!this.navigation.getParamValue('ingredients.addInDialog', true)) {
      this.router.navigate(['/ingredients/add']);
      return;
    }
    this.ingredientAddDialog = this.dialogService.open(DialogIngredientFormComponent, {
      header: '', // this.translate.instant('NEWINGREDIENT'),
      width: '80%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'add',
        ingredient: {id: null},
        users: this.ingredientsColumnsService.users,
      },
    });

    this.ingredientAddDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Ingredient added'});
        this.getIngredients();
      }
    });
  }

  ingredientEdit(ingredient: Ingredient): void {
    if (!this.navigation.getParamValue('ingredients.editInDialog', true)) {
      this.router.navigate(['/ingredients/edit/' + ingredient.id]);
      return;
    }
    this.ingredientEditDialog = this.dialogService.open(DialogIngredientFormComponent, {
      header: '', // this.translate.instant('EDITINGREDIENT') + ' ' + ingredient.name,
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'edit',
        ingredient: ingredient,
        users: this.ingredientsColumnsService.users,
      },
    });

    this.ingredientEditDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'Ingredient updated'});
        this.getIngredients();
      }
    });
  }

  ingredientDetails(ingredient: Ingredient): void {
    if (!this.navigation.getParamValue('ingredients.detailsInDialog', true)) {
      this.router.navigate(['/ingredients/details/' + ingredient.id]);
      return;
    }
    this.ingredientDetailsDialog = this.dialogService.open(DialogIngredientDetailsComponent, {
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        ingredient: ingredient,
      }
    });
  }

  ingredientDelete(ingredient: Ingredient): void {
    this.ingredientToDelete = ingredient;
    this.messageService.clear();
    this.messageService.add({
      key: 'ingredientDelete',
      sticky: true,
      severity: 'warn',
      summary: 'Are you sure you want delete ' + ingredient.name + ' ?',
      detail: 'Confirm to proceed'
    });
  }

  onDeleteConfirm(): void {
    this.ingredientsDataService.deleteIngredient(this.ingredientToDelete).subscribe((res: any) => {
      this.messageService.clear();
      this.messageService.add({severity: 'success', summary: 'Success', detail: 'Ingredient deleted'});
      this.getIngredients();
    }, (error: any) => {
      this.messageService.clear();
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Ingredient not deleted'});
    });
  }

  onDeleteReject(): void {
    this.ingredientToDelete = {};
    this.messageService.clear('ingredientDelete');
  }

}
